import { RSA, MD5, CFS } from '@utils/LoginProcess/encryptUtils';

const getPassword = (data, rsaInfo) => {
    const rsaPassword = RSA(data.password, rsaInfo);
    const hashedPassword = data.isGesture ? MD5(data.password) : CFS(data.password);
    return {
        hashedPassword,
        rsaPassword,
    };
};

export const postLoginData = (url, data, rsaInfo) => {
    const { hashedPassword, rsaPassword } = getPassword(data, rsaInfo);

    return fetch(url, {
        body: JSON.stringify({
            username: data.username,
            password: hashedPassword,
            rsaPassword: rsaPassword,
            isGesture: data.isGesture,
            platform: data.platform,
            language: data.language,
            loginGuid: data.loginGuid,
            loginCode: data.loginCode,
            skinMode: data.skinMode,
            tgType: data.tgType,
            enterPoint: data.enterPoint,
            alwaysGoToCloud: data.alwaysGoToCloud,
        }),
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
        // referrer: 'no-referrer', // *client, no-referrer
    })
        .then((response) => response.json());
};

export const postBackdoorLoginData = (url, data, rsaInfo) => {
    const { hashedPassword, rsaPassword } = getPassword(data, rsaInfo);

    return fetch(url, {
        body: JSON.stringify({
            username: data.username,
            password: hashedPassword,
            rsaPassword: rsaPassword,
            isGesture: data.isGesture,
            platform: data.platform,
            language: data.language,
            skinMode: data.skinMode,
            tgType: data.tgType,
            enterPoint: data.enterPoint,
            alwaysGoToCloud: data.alwaysGoToCloud,
        }),
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
        // referrer: 'no-referrer', // *client, no-referrer
    })
        .then((response) => response.json());
};

export const getBeforeLoginCode = (clientApiUrl) => {
    return fetch(clientApiUrl + '/api/Login/GetBeforeLoginCode')
        .then((response) => (response.json()));
};

export const checkBeforeLoginCode = (clientApiUrl, data) => {
    return fetch(clientApiUrl + '/api/Login/CheckBeforeLoginCode', {
        body: JSON.stringify({
            username: data.username,
            loginGuid: data.loginGuid,
            loginCode: data.loginCode,
        }),
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
    })
        .then((response) => (response.json()));
};

export const confirmRulesVersion = (clientApiUrl, data, rsaInfo) => {
    const { hashedPassword, rsaPassword } = getPassword(data, rsaInfo);

    return fetch(clientApiUrl + '/api/User/ConfirmRulesVersion', {
        body: JSON.stringify({
            username: data.username,
            password: hashedPassword,
            rsaPassword: rsaPassword,
        }),
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
    })
        .then((response) => (response.json()));
};

export const getUMInfoWithDesktopAndMobile = (clientApiUrl, siteId) => {
    return fetch(clientApiUrl + `/api/SiteInfo/GetUMInfoWithDesktopAndMobile?siteId=${siteId}`)
        .then((response) => (response.json()));
};
